import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from '@material-ui/core/Paper';
import Zoom from '@material-ui/core/Zoom';
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import Typography from "@material-ui/core/Typography";
import { vodafoneDoneColor, vodafoneFont } from "../api/data";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import { IconButton, Grow } from "@material-ui/core";
import "../styles/vStyles.css";
const tickIcon = require("../assets/img/tick-simple.svg");
const useStyles = makeStyles(theme => ({
  paper: {
    padding: "6px 16px"
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main
  }, 
  oppositeContent: {
    // TODO: adjust this value accordingly
    maxWidth:"5px", padding: "0px 0px"
    
  }
}));

interface Props {
    timelineProgress: any,
    timelineCreated: any, 
    timelineFinished: any, 
    currentStatus : string,
    startTime: any
  }

const erstellen = "Created";
const bearbeitung = "PROGRESS";
const fertig = "CLOSED"; 
const erstelltText = "Dein Störungsticket wird in Kürze von unserern Mitarbeitern bearbeitet. Du siehst den aktuellen Status jederzeit über den Link in deiner SMS oder E-Mail.";
const fertigText = "Die Störung ist behoben und dein Ticket geschlossen. Falls es nochmal ein Problem gibt, melde dich bitte bei uns.";

export const TimelineComponent= (props: Props) => {
  const { timelineProgress, currentStatus, timelineCreated, timelineFinished} = props;

  const [openBearbeitung, setOpenBearbeitung] = React.useState(true);
  function detailToggleBearbeitung() {
    setOpenBearbeitung(!openBearbeitung);
  }
  const [openCreated, setOpenCreated] = React.useState(true);
  function detailToggleCreated() {
    setOpenCreated(!openCreated);
  }
  const [openFinished, setOpenFinished] = React.useState(true);
  function detailToggleFinished() {
    setOpenFinished(!openFinished);
  }
  const classes = useStyles();  
  return (    
      <Timeline align="left">
        <Zoom in = {true} style={{ transitionDelay: '500ms'}}>
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot style={{stroke:"white", backgroundColor:vodafoneDoneColor, marginTop: '0px'}}>                               
                <IconButton onClick={detailToggleCreated} size={"small"}>
                  <img src={tickIcon} alt="" width="30" height="30"/>
                </IconButton>                
               </TimelineDot>          
              { CreateTimelineConnector("erstellt", currentStatus) }
            </TimelineSeparator>
            <TimelineContent>
              <Typography variant="body2" style={{color:'black', fontFamily:vodafoneFont , fontWeight:'bold', fontSize:"20px"}}>
                  { "Ticket erstellt" }
              </Typography> 
              { openCreated ?
                  <Grow
                    in={openCreated}
                    style={{ transformOrigin: '0 0 0' }}
                    {...(openCreated ? { timeout: 2000 } : {})}>
                  <Paper elevation={0} className={classes.paper}> <text style={{ fontFamily: vodafoneFont, fontSize: "16px" }}> {timelineCreated[1] ?
                    timelineCreated[1].text:''} </text> 
                  <text style={{ fontFamily: vodafoneFont, fontSize: "16px" }}>{timelineCreated[0] ? editmessages(timelineCreated) : erstelltText}</text>
                    </Paper>
                  </Grow>              
                    : ""
                }             
            </TimelineContent>
            <TimelineOppositeContent
              className={classes.oppositeContent}>
            </TimelineOppositeContent>
          </TimelineItem>
        </Zoom>
        <Zoom in = {true} style={{ transitionDelay: '1000ms'}}>
          <TimelineItem>
              <TimelineSeparator>                  
                <TimelineDot style={{stroke:"white", backgroundColor:vodafoneDoneColor, marginTop: '2px'}}>
                  <IconButton onClick={detailToggleBearbeitung} size={"small"}>
                    <img src={tickIcon} alt="" width="30" height="30"/>  
                  </IconButton> 
                </TimelineDot>
                { CreateTimelineConnector(bearbeitung, currentStatus) }
              </TimelineSeparator>
              <TimelineContent>
                <Typography variant="body2" style={{color:'black', fontFamily:vodafoneFont , fontWeight:'bold', fontSize:"20px"}}>
                  { "In Bearbeitung" }
                </Typography>
                { openBearbeitung ?
                  <Grow
                    in={openBearbeitung}
                    style={{ transformOrigin: '0 0 0' }}
                    {...(openBearbeitung ? { timeout: 2000 } : {})}>
                    <Paper elevation={0} className={classes.paper} > <text> {timelineProgress[1] ? 
                    timelineProgress[1].text:""} </text> {timelineProgress[0] ? editmessages(timelineProgress):""}                                  </Paper>
                  </Grow>              
                    : ""
                }
              </TimelineContent>
              <TimelineOppositeContent
                className={classes.oppositeContent}>
              </TimelineOppositeContent>
            </TimelineItem>
        </Zoom>
        {currentStatus.toUpperCase() === 'CLOSED'&&          
        <Zoom in = {true} style={{ transitionDelay: '1500ms'}}>
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot style={{stroke:"white", backgroundColor:vodafoneDoneColor, marginTop: '2px'}}> 
                <IconButton onClick={detailToggleFinished} size={"small"}> 
                  <img src={tickIcon} alt="" width="30" height="30"/> 
                </IconButton>    
              </TimelineDot>
            </TimelineSeparator>
            <TimelineContent>
              <Typography variant="body2" style={{color:'black', fontFamily:vodafoneFont, fontWeight:'bold', fontSize:"20px"}}>
                {"Fertig"}
              </Typography>
              { openFinished ?
                  <Grow
                    in={openFinished}
                    style={{ transformOrigin: '0 0 0' }}
                    {...(openFinished ? { timeout: 2000 } : {})}>
                    <Paper elevation={0} className={classes.paper}> <text style={{ fontFamily: vodafoneFont, fontSize: "16px" }}> {timelineFinished[1] ?
                    timelineFinished[1].text:fertigText} </text> {timelineFinished[0] ? editmessages(timelineFinished):""}                                  
                    </Paper>
                  </Grow>              
                    : ""
                }              
            </TimelineContent>
            <TimelineOppositeContent
              className={classes.oppositeContent}>
            </TimelineOppositeContent>
          </TimelineItem>
        </Zoom> }
      </Timeline>   
  );
}
function editmessages(data: any) {
  // console.log(new Date(`${data[0].activityStart.startDate?.split('/').reverse().join('-')} ${data[0].activityStart.startTime}`))
  data = data.sort((obj1, obj2)=>{
    return (+new Date(`${obj2.activityStart.startDate?.split('/').reverse().join('-')} ${obj2.activityStart.startTime}`) - 
    +new Date(`${obj1.activityStart.startDate?.split('/').reverse().join('-')} ${obj1.activityStart.startTime}`))
  }).sort((obj1, obj2)=>{
    return (+new Date(`${obj2.activityFinish?.finishDate?.split('/').reverse().join('-')} ${obj2.activityFinish?.finishTime}`) - 
    +new Date(`${obj1.activityFinish?.finishDate?.split('/').reverse().join('-')} ${obj1.activityFinish?.finishTime}`))
  });
  // console.log(data);
  let messages = [];
  for (let index = 0; index < data.length; index++) {
    messages.push(
      <div>
        <Typography style={{fontFamily:vodafoneFont, fontSize:"16px"}}> {data[index].activityFinish ?
          data[index].activityFinish.finishDate +'\xa0\xa0\xa0' +   data[index].activityFinish.finishTime :
          data[index].activityStart.startDate +'\xa0\xa0\xa0' + data[index].activityStart.startTime} </Typography>
        <Typography style={{fontFamily:vodafoneFont, fontSize:"16px"}}> {data[index].customerMessage}</Typography>
        <br/>
      </div>
    )    
  } 
  return messages;
}

function CreateTimelineConnector(status: string, currentStatus: string) {
  switch(currentStatus) {
    case fertig:
      return <TimelineConnector />;
    case bearbeitung:
      return status ===bearbeitung ? "": <TimelineConnector />;
    case erstellen:
        return status ===erstellen ? "": ""; 
  }
}

